import { render } from "./SectInfoView.vue?vue&type=template&id=7b1f5eda&scoped=true"
import script from "./SectInfoView.vue?vue&type=script&lang=js"
export * from "./SectInfoView.vue?vue&type=script&lang=js"

import "./SectInfoView.vue?vue&type=style&index=0&id=7b1f5eda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1f5eda"]])

export default __exports__